// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__vJxiN","title":"ClientReferral_title__2106x","itemText":"ClientReferral_itemText__3Jb0K"};